import {
  Button,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material'
import { ReactElement } from 'react'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'

import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import Loading from 'src/v3/components/loading'
import { selectRoles, selectUserID } from 'src/v3/settings/settings.slice'
import {
  selectClassID,
  selectCurrentStep,
  selectProgress,
  selectStreamItems,
  stepCompleted,
  steppedBackward,
  steppedForward,
} from '../classroom.slice'

export default (): ReactElement => {
  let dispatch = useAppDispatch()
  let classID = useAppSelector(selectClassID)
  let userID = useAppSelector(selectUserID)
  let items = useAppSelector(selectStreamItems)
  let progress = useAppSelector(selectProgress)
  let currentStep = useAppSelector(selectCurrentStep)
  let roles = useAppSelector(selectRoles)
  let isAdmin = roles.includes('admin')
  let isSpecialAccess =
    userID === 'a7c45cd4-6118-491a-98d6-0b340ee6e954' ||
    userID === '91e3b1e3-8334-4d0e-a4f1-207c0e7598a2'

  let nextStep = () => {
    if (items) {
      if (items[currentStep]?.type === 'title_screen') {
        axios
          .post('/api/v2/classroom/stream-event/title-screen', {
            classID,
            titleScreenID: items[currentStep]?.id,
            status: 'completed',
          })
          .then(() => {
            dispatch(stepCompleted())
            dispatch(steppedForward())
          })
      }
      if (items[currentStep]?.type === 'video') {
        // Video dispatches completion event on its own
        dispatch(steppedForward())
      }
      if (items[currentStep]?.type === 'text_content') {
        axios
          .post('/api/v2/classroom/stream-event/text-content', {
            classID,
            textContentID: items[currentStep]?.id,
            status: 'completed',
          })
          .then(() => {
            dispatch(stepCompleted())
            dispatch(steppedForward())
          })
      }
      if (items[currentStep]?.type === 'show_notes') {
        axios
          .post('/api/v2/classroom/stream-event/show-notes', {
            classID,
            showNotesID: items[currentStep]?.id,
            status: 'completed',
          })
          .then(() => {
            dispatch(stepCompleted())
            dispatch(steppedForward())
          })
      }
    }
  }

  return (
    <>
      <Stepper
        activeStep={currentStep}
        orientation="vertical"
        style={{ backgroundColor: 'inherit' }}
      >
        {progress.map((_, i) => (
          <Step key={i}>
            <StepLabel>{items?.[i]?.name}</StepLabel>
            <StepContent>
              <Typography>{items?.[i]?.description}</Typography>
              <div>
                <div>
                  <Button
                    disabled={currentStep === 0}
                    onClick={() => dispatch(steppedBackward())}
                  >
                    Back
                  </Button>
                  {currentStep !== progress.length - 1 && (
                    <Button
                      disabled={
                        !isAdmin &&
                        !isSpecialAccess &&
                        (!progress.length ||
                          (progress[currentStep]?.type !== 'textContent' &&
                            progress[currentStep]?.type !== 'titleScreen' &&
                            progress[currentStep]?.type !== 'showNotes' &&
                            progress[currentStep]?.status !== 'completed'))
                      }
                      variant="contained"
                      color="primary"
                      onClick={nextStep}
                      endIcon={
                        isAdmin || isSpecialAccess ? (
                          <AdminPanelSettingsIcon />
                        ) : null
                      }
                    >
                      Next
                    </Button>
                  )}
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Loading entities={['fulfilled']} loading={progress.length === 0} />
    </>
  )
}
